/*
 * @FilePath     : /es-package/packages/es-mpx-router/lib/Router.js
 * @Author       : LiYang
 * @Date         : 2021-08-12 18:38:49
 * @LastEditTime : 2022-02-28 15:13:42
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
import { stringifyQuery, toPromise, versionValid } from '@didi/es-mpx-shared'
import webview from './webview'
export default class Router{
  constructor(app) {
    this.beforeHooks = [];
    this.afterHooks = [];
    this.app = app;
  }

  beforeEach(callback) {
    this.beforeHooks.push(callback);
    return () => {
      const idx = this.beforeHooks.indexOf(callback);
      if (idx > -1) this.beforeHooks.splice(idx, 1)
    }
  }

  afterEach(callback) {
    this.afterHooks.push(callback);
    return () => {
      const idx = this.afterHooks.indexOf(callback);
      if (idx > -1) this.afterHooks.splice(idx, 1)
    }
  }

  enter(context) {
    this.route = {
      url: context.route,
      query: context.query
    }
    this.afterHooks.forEach(cb => cb(context))
  }

  handleRouter(to, cb) {
    const { beforeHooks } = this;
    const dispatch = index => {
      let fn = beforeHooks[index];
      if (!fn) {
        cb(to)
        return
      };
      fn(to, (url) => {
        if (url === false) {
          return;
        }
        typeof url === 'string' && (to = url);
        dispatch(index + 1)
      })
    }
    dispatch(0);
  }

  navigation(url, params = {}, type = 'navigateTo') {
    const { stringifyQuery, transformOption, app } = this;
    
    return toPromise((accept, reject) => {
      return this.handleRouter(
        stringifyQuery(url, params), 
        (to) =>  app[type](transformOption(to, accept, reject))
      )  
    })
  }

  transformOption(url, success, fail) {
    const props = isNaN(parseInt(url)) ? 'url' : 'delta' 
    return {
      success,
      fail,
      [props]: url
    }
  }

  stringifyQuery(url, params) {
    if (typeof url === 'number') {
      return url;
    }
    return url.concat(
      stringifyQuery(params).replace('?', url.includes('?') ? '&' : '?')
    )
  }

  redirect(url, params) {
    return this.navigation(url, params, 'redirectTo')
  }
  push(url, params) {
    return this.navigation(url, params, 'navigateTo')
  }

  switch(url, params) {
    return this.navigation(url, params, 'switchTab')
  }

  replace(url, params) {
    return this.navigation(url, params, 'reLaunch')
  }

  goback(url = 1, params) {
    const useH5Bridge = versionValid()
    console.log(versionValid, useH5Bridge, 'useH5Bridge');
    if(useH5Bridge) {
      import('@didi/eslite-bridge/lib/bridge/didies/index').then(res => {
        const K = res.default || res || {}
        return K.goBackPage({url, params})
      })
    } else {
      return this.navigation(url, params, 'navigateBack')
    }
  }

  webview(url, params) {
    const uri = params ? this.stringifyQuery(url, params) : url;
    const _this = this;
    return toPromise((success, fail) => {
      webview.call(_this, uri, success, fail)
    })
  }
}
